<template>
    <div class="search-bar">
        <input
            type="text"
            :placeholder="this.trans(placeholder)"
            v-model="query"
            data-test="input"
        >

        <button @click="filter">
            <img src="/images/icons/scope.svg">
        </button>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus';

    export default {
        props: {
            placeholder: String,
            debounceInput: Boolean
        },

        data() {
            return {
                query: '',
                debouncedFilter: null
            }
        },
        watch: {
            query() {
                this.filter();
            }
        },

        mounted() {
            this.query = localStorage.getItem('query') || '';
            localStorage.removeItem('query');

            this.debouncedFilter = this.debounce(() => {
                this.emitFilterEvent();
            },500)
        },

        methods: {
            filter() {
                this.debounceInput ? this.debouncedFilter() : this.emitFilterEvent();
            },
            emitFilterEvent() {
                EventBus.$emit('onFilter', this.query);
            }
        }
    }
</script>
